import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, mapProps, branch, renderComponent } from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'
import * as R from 'ramda'

import { Table, TableHead, TableRow, TableCell } from 'react-toolbox/lib/table'

const EditButton = ({onClick, styles}) => {
  return (
    <IconButton
      primary
      theme={styles}
      icon='edit'
      onClick={onClick}
    />
  )
}

const addEditButtonToSource = (onClick) => R.map(({ id, ...rest }) => ({
  ...rest,
  id,
  action: <EditButton onClick={() => onClick(id)}/>
}))

const addEmptyStringToSource = R.map(value => ({ ...value, action: '' }))


const getTableHead = (tableHeadContent) =>  (
    <TableHead>
        {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
)

const getModifyTableRows = (source, tableHeadContent, selected) => {

    const mapIndexed = R.addIndex(R.map);
    return(
        mapIndexed((rowContent, idx) => {
          return (
            <TableRow key={idx} selected={R.contains(idx, selected)}>
                {mapIndexed((key, idx) => (
                    <TableCell key={idx}>{(rowContent && rowContent[key]) ? rowContent[key] : ""}</TableCell>
                ), R.keys(tableHeadContent))}
            </TableRow>
        )}, source)
    )
}

const getViewTableRows = (source, tableHeadContent) => {
    const mapIndexed = R.addIndex(R.map);
    return(
        mapIndexed((rowContent, idx) => {
          return(
            <TableRow key={idx}>
                {mapIndexed((key, idx) => (
                    <TableCell key={idx}>{(rowContent && rowContent[key]) ? rowContent[key] : ""}</TableCell>
                ), R.keys(tableHeadContent))}
            </TableRow>
        )}, source)
    )
}

const ModifyTable = ({ tableHeadContent, styles, onSelect, source, selectable, selected, noRowSelection }) => {
  const selecting = selectable && !noRowSelection
    return (
        <div className="tableContainer" style={{overflow: 'auto'}}>
            <Table
                multiSelectable={false}
                selectable={selecting}
                selected={selected}
                onRowSelect={([selected]) => {onSelect(source[selected])}}
                theme={styles}>
                {getTableHead(tableHeadContent)}
                {getModifyTableRows(source, tableHeadContent, selected)}
            </Table>
        </div>
    )
}

const ViewTable = ({ tableHeadContent, styles, onSelect, source, selectable, ...rest }) => {
    return (
        <div className="tableContainer" style={{overflow: 'auto'}}>
            <Table
                multiSelectable={false}
                selectable={false}
                theme={styles}>
                {getTableHead(tableHeadContent)}
                {getViewTableRows(source, tableHeadContent)}
            </Table>
        </div>
    )
}

const withModifyProps = mapProps(
  ({source, editRoles, ...rest}) => ({
    ...rest,
    source: addEditButtonToSource(editRoles)(source)
  })
)

const withViewProps = mapProps(
  ({source, ...rest}) => ({
    ...rest,
    source: addEmptyStringToSource(source)
  })
)

const enhance = R.curry((SelectableView, UnselectableView) => branch(
  ({ selectable }) => selectable,
  renderComponent(SelectableView)
)(UnselectableView))

export {
  withModifyProps,
  withViewProps,
  ModifyTable,
  ViewTable,
  enhance
}
